import React from 'react'
import {Outlet} from 'react-router-dom';
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";

const Integration = () => {
    return <React.Fragment>
        <DashboardLayout>
            <Outlet/>
        </DashboardLayout>
    </React.Fragment>
};

export default Integration;

